import React, { useEffect, useState } from "react";
import { api, ENROLL_STATUSES, fmtDate } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { useNavigate } from "react-router-dom";

export default function Enrollment() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("all");
  const nav = useNavigate();
  useEffect(() => {
    const qs = status !== "all" ? `?status=${encodeURIComponent(status)}` : "";
    api.get(`/enrollments${qs}`).then(r => setRows(r.data));
  }, [status]);

  return (
    <div className="space-y-6">
      <div><h1 className="heading-font text-3xl font-bold text-slate-900">Enrollment</h1><p className="text-sm text-slate-500 mt-1">Track semester enrollment for admitted students.</p></div>
      <div className="bg-white p-3 rounded-xl border border-slate-200 flex gap-2 items-center">
        <span className="text-xs uppercase text-slate-500 pl-1">Status</span>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-64 h-9 bg-white" data-testid="enrollment-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All</SelectItem>{ENROLL_STATUSES.map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
            <tr><th className="text-left px-4 py-3">Student</th><th className="text-left px-4 py-3">College</th><th className="text-left px-4 py-3">Intake</th><th className="text-left px-4 py-3">Status</th><th className="text-left px-4 py-3">Sem 1</th><th className="text-left px-4 py-3">Sem 2</th></tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={()=>r.application && nav(`/applications/${r.application.id}`)}>
                <td className="px-4 py-3 font-medium">{r.application?.student_name || "—"}<div className="text-xs text-slate-500 mono">{r.application?.application_id}</div></td>
                <td className="px-4 py-3">{r.application?.college}</td>
                <td className="px-4 py-3">{r.application?.intake}</td>
                <td className="px-4 py-3"><span className="stage-badge bg-teal-50 text-teal-900 border-teal-300">{r.status}</span></td>
                <td className="px-4 py-3 text-xs">{r.semester1_confirmed ? "✅ " : ""}{fmtDate(r.semester1_start)}</td>
                <td className="px-4 py-3 text-xs">{r.semester2_confirmed ? "✅ " : ""}{fmtDate(r.semester2_start)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-slate-500">No enrollment records yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
